import React from 'react';
import { Box } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

const SimSliderContainer = ({ maxWidth, slideProps = {}, dotSx = {}, prevSx = {}, nextSx = {}, children }) => {
	const theme = useTheme();
	const width = maxWidth || { xs: '75vw', sm: '80vw', md: '80vw', lg: '90vw' };

	return (
		<Box maxWidth={width} marginX={'auto'} paddingX={'auto'} marginY={0} paddingY={0}>
			<Box
				{...slideProps}
				sx={{
					height: { xs: 'auto', md: 1 },
					'& .slick-slide img': {
						objectFit: 'cover'
					},
					'& .slick-list, & .slick-slider, & .slick-track, & .slick-slide > div': {
						height: { xs: 'auto', md: 1 }
					},
					'& .slick-dots': {
						marginTop: { xs: 16, sm: 12, md: 12, lg: 14 },
						top: { xs: '84%', sm: '90%', md: '87%' },
						height: '25px',
                        ...dotSx
					},
					'& .slick-prev': {
						zIndex: 3,
						bottom: 0,
						top: '100%',
						left: '0%',
						marginLeft: 0,
						marginRight: 32,
						right: 0,
						transform: `translate(-100%, calc(-100% - ${theme.spacing(2)}))`,
						marginTop: { xs: '15px', sm: '15px', md: '15px', lg: '15px' },
						width: { xs: 26, sm: 26, md: 52, lg: 52 },
						height: '100%',
						'&:before': {
							fontSize: { xs: 26, sm: 26, md: 52, lg: 52 },
							color: alpha(theme.palette.primary.main, 0.5)
						},
                        ...prevSx
					},
					'& .slick-next': {
						zIndex: 3,
						bottom: 0,
						top: '100%',
						left: '100%',
						marginLeft: '32px',
						right: 0,
						transform: `translate(-100%, calc(-100% - ${theme.spacing(2)}))`,
						marginTop: { xs: '15px', sm: '15px', md: '15px', lg: '15px' },
						width: { xs: 32, sm: 32, md: 32, lg: 32 },
						height: '100%',
						'&:before': {
							fontSize: { xs: 26, sm: 26, md: 52, lg: 52 },
							color: alpha(theme.palette.primary.main, 0.5)
						},
                        ...nextSx
					}
				}}>
				{children}
			</Box>
		</Box>
	);
};

export { SimSliderContainer };
